import React from 'react';

export const image = (
  <svg
    width="224"
    height="192"
    viewBox="0 0 224 192"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_7581_10347)">
      <path
        d="M22 32.945C22 25.2434 28.2634 19 35.9896 19H190.01C197.737 19 204 25.2434 204 32.945V157.055C204 164.757 197.737 171 190.01 171H35.9896C28.2634 171 22 164.757 22 157.055V32.945Z"
        fill="white"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M53 39.5C53 38.1193 54.2329 37 55.7538 37H71.2462C72.7671 37 74 38.1193 74 39.5C74 40.8807 72.7671 42 71.2462 42H55.7538C54.2329 42 53 40.8807 53 39.5Z"
      fill="#EBEDEF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M35 61C35 59.3431 36.2536 58 37.8 58H102.2C103.746 58 105 59.3431 105 61C105 62.6569 103.746 64 102.2 64H37.8C36.2536 64 35 62.6569 35 61Z"
      fill="#EBEDEF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M35 71.5C35 70.1193 36.2264 69 37.7393 69L50.2607 69C51.7736 69 53 70.1193 53 71.5C53 72.8807 51.7736 74 50.2607 74L37.7393 74C36.2264 74 35 72.8807 35 71.5Z"
      fill="#FBE4FF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M56 71.5C56 70.1193 57.2264 69 58.7393 69L71.2607 69C72.7736 69 74 70.1193 74 71.5C74 72.8807 72.7736 74 71.2607 74L58.7393 74C57.2264 74 56 72.8807 56 71.5Z"
      fill="#DBF3FB"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M35 90C35 88.3431 36.247 87 37.7853 87L112.215 87C113.753 87 115 88.3432 115 90C115 91.6569 113.753 93 112.215 93L37.7853 93C36.247 93 35 91.6568 35 90Z"
      fill="#EBEDEF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M35 100C35 98.3431 36.247 97 37.7853 97L112.215 97C113.753 97 115 98.3432 115 100C115 101.657 113.753 103 112.215 103L37.7853 103C36.247 103 35 101.657 35 100Z"
      fill="#EBEDEF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M35 110C35 108.343 36.2365 107 37.7619 107H90.2381C91.7635 107 93 108.343 93 110C93 111.657 91.7635 113 90.2381 113H37.7619C36.2365 113 35 111.657 35 110Z"
      fill="#EBEDEF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M165 50C165 48.3431 166.215 47 167.714 47L181.286 47C182.785 47 184 48.3431 184 50C184 51.6569 182.785 53 181.286 53L167.714 53C166.215 53 165 51.6569 165 50Z"
      fill="#EBEDEF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M138 80.5C138 79.1193 139.246 78 140.783 78L167.217 78C168.754 78 170 79.1193 170 80.5C170 81.8807 168.754 83 167.217 83L140.783 83C139.246 83 138 81.8807 138 80.5Z"
      fill="#EBEDEF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M138 99C138 97.3431 139.246 96 140.783 96L167.217 96C168.754 96 170 97.3431 170 99C170 100.657 168.754 102 167.217 102L140.783 102C139.246 102 138 100.657 138 99Z"
      fill="#EBEDEF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M138 110C138 108.343 139.246 107 140.783 107L167.217 107C168.754 107 170 108.343 170 110C170 111.657 168.754 113 167.217 113L140.783 113C139.246 113 138 111.657 138 110Z"
      fill="#EBEDEF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M138 121C138 119.343 139.246 118 140.783 118L167.217 118C168.754 118 170 119.343 170 121C170 122.657 168.754 124 167.217 124L140.783 124C139.246 124 138 122.657 138 121Z"
      fill="#EBEDEF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M165 40C165 38.3431 166.254 37 167.8 37H176.2C177.746 37 179 38.3431 179 40C179 41.6569 177.746 43 176.2 43H167.8C166.254 43 165 41.6569 165 40Z"
      fill="#CEF4E6"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M138 71C138 69.3431 139.248 68 140.788 68L181.212 68C182.752 68 184 69.3431 184 71C184 72.6569 182.752 74 181.212 74L140.788 74C139.248 74 138 72.6569 138 71Z"
      fill="#CEF4E6"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M138 147C138 145.343 139.248 144 140.788 144L181.212 144C182.752 144 184 145.343 184 147C184 148.657 182.752 150 181.212 150L140.788 150C139.248 150 138 148.657 138 147Z"
      fill="#CEF4E6"
    />
    <path
      d="M48 39.5C48 43.0899 45.0899 46 41.5 46C37.9101 46 35 43.0899 35 39.5C35 35.9101 37.9101 33 41.5 33C45.0899 33 48 35.9101 48 39.5Z"
      fill="#EBEDEF"
    />
    <path
      d="M158 44C158 49.5228 153.299 54 147.5 54C141.701 54 137 49.5228 137 44C137 38.4772 141.701 34 147.5 34C153.299 34 158 38.4772 158 44Z"
      fill="#EBEDEF"
    />
    <path
      d="M35 125.455C35 122.442 37.4821 120 40.5439 120H108.456C111.518 120 114 122.442 114 125.455V144.545C114 147.558 111.518 150 108.456 150H40.5439C37.4821 150 35 147.558 35 144.545V125.455Z"
      fill="#EBEDEF"
    />
    <circle cx="21.5" cy="93.5" r="21.5" fill="#ED7474" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.5578 85.0823H17.7527C17.21 85.0823 16.7698 84.643 16.7698 84.1013C16.7698 83.5596 17.21 83.1203 17.7527 83.1203H24.558C25.1007 83.1203 25.5406 83.5596 25.5406 84.1013C25.5406 84.643 25.1005 85.0823 24.5578 85.0823ZM12.8446 86.3175H29.4661C30.0088 86.3175 30.4489 86.7568 30.4489 87.2985C30.4489 87.8402 30.0088 88.2795 29.4661 88.2795H28.4615V100.563C28.4615 101.983 27.3047 103.137 25.8828 103.137H16.3977C14.9758 103.137 13.819 101.983 13.819 100.563V88.2795H12.8446C12.3019 88.2795 11.8618 87.8402 11.8618 87.2985C11.8618 86.7568 12.3019 86.3175 12.8446 86.3175ZM25.883 101.175C26.2211 101.175 26.496 100.901 26.496 100.563V88.2795H15.7848V100.563C15.7848 100.901 16.0598 101.175 16.3979 101.175H25.883ZM19.0646 99.2493C19.6073 99.2493 20.0474 98.81 20.0474 98.2683V91.4456C20.0474 90.9039 19.6073 90.4646 19.0646 90.4646C18.5218 90.4646 18.0817 90.9039 18.0817 91.4456V98.2683C18.0817 98.81 18.5218 99.2493 19.0646 99.2493ZM24.1387 98.2683C24.1387 98.81 23.6986 99.2493 23.1559 99.2493C22.6132 99.2493 22.1731 98.81 22.1731 98.2683V91.4456C22.1731 90.9039 22.6132 90.4646 23.1559 90.4646C23.6986 90.4646 24.1387 90.9039 24.1387 91.4456V98.2683Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_d_7581_10347"
        x="2"
        y="0"
        width="222"
        height="192"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="10" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_7581_10347" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_7581_10347"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
